import React, { createContext, FC, useContext } from 'react';

export const NodeSelectedContext = createContext<boolean>(false);

interface NodeSelectedContextProviderProps {
    nodeSelected: boolean;
    children: React.ReactNode;
}

export const NodeSelectedContextProvider: FC<NodeSelectedContextProviderProps> = props => {
    return <NodeSelectedContext.Provider value={props.nodeSelected}>{props.children}</NodeSelectedContext.Provider>;
};

export function useNodeSelected() {
    return useContext(NodeSelectedContext);
}
